import { useEffect } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

import ModalWrapper, {
  ModalBody,
  showModalWrapper,
} from 'components/ModalWrapper'
import DisconnectConfirmation from 'components/DisconnectConfirmation'
import { ContentRefreshDomain } from '@pepper/utils/src/types/domain'

import s from './RemoveIntegrationModal.module.css'

type Props = {
  onDisconnect: () => void
  domains: ContentRefreshDomain[]
}

export const RemoveIntegrationModal = NiceModal.create(
  ({ onDisconnect, domains }: Props) => {
    const { visible: isModalVisible, remove: removeSelfModal } =
      useModal('remove-integration')

    useEffect(() => {
      if (isModalVisible) showModalWrapper()
    }, [isModalVisible])

    const handleDisconnect = () => {
      onDisconnect()
      removeSelfModal()
    }

    return (
      <ModalWrapper
        modalId="remove-integration"
        id="seo-headless-modal"
        width={594}
        closable={false}
        className={s.removeIntegrationModal}
      >
        <ModalBody>
          <div className={s.content}>
            <DisconnectConfirmation
              onDisconnect={handleDisconnect}
              onCancel={removeSelfModal}
              connectedDomains={domains}
            />
          </div>
        </ModalBody>
      </ModalWrapper>
    )
  }
)
